import { render, staticRenderFns } from "./TranslationsActionsPane.vue?vue&type=template&id=84dea2da&scoped=true&"
import script from "./TranslationsActionsPane.vue?vue&type=script&lang=ts&"
export * from "./TranslationsActionsPane.vue?vue&type=script&lang=ts&"
import style0 from "./TranslationsActionsPane.vue?vue&type=style&index=0&id=84dea2da&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dea2da",
  null
  
)

export default component.exports